import React from 'react';
import styled from 'styled-components';
import {actionIcCheckCircle24px, contentIcRemoveCircleOutline24px} from '@ey/motif-react-wrapper/assets/icons/index';
import EllipseControl from '../../EllipsesControl/EllipsesControl';
import {riskTypeIdEnum} from '../../../../util/uiconstants';
import {useOverrideLabels} from '../../../Main/Forms/Utilities/OverrideLabelsProvider';
import Icon from '../../BaseComponentWrappers/MotifIcon';

const DefineRiskItem = (props) => {
	const {labels} = useOverrideLabels();

	const getRiskTypeIndicator = (riskTypeId) => {
		switch (riskTypeId) {
			case riskTypeIdEnum.significant:
				return (
					<span className="risk-badge">
						<span className="risktype-badge">{labels.significantRiskIndicator}</span>
					</span>
				);
			case riskTypeIdEnum.fraud:
				return (
					<span className="risk-badge">
						<span className="risktype-badge">{labels.fraudRiskIndicator}</span>
					</span>
				);
		}
	};

	return (
		<>
			<StyledDefineRiskItem className="StyledDefineRiskItemLI">
				<section className="riskfactor-name">{props.item.riskFactorName.substring(0, 500)}</section>
				{props.item.customDescription ? (
					<section className="riskfactor-description">{props.item.customDescription.substring(0, 500)}</section>
				) : (
					<section className="riskfactor-description description-incomplete">
						<Icon src={contentIcRemoveCircleOutline24px} />
						{labels.descriptionIncompleteLabel}
					</section>
				)}
				{!props.item.isNotMaterial ? (
					props.item.riskId ? (
						<section className="related-risks">
							<span className="relatedrisk-name">
								<Icon src={actionIcCheckCircle24px} />
								<span className="relatedrisk-name-label">{props.item.riskName}</span>
							</span>
							{getRiskTypeIndicator(props.item.riskTypeId)}
						</section>
					) : (
						<section className="related-risks">
							<span className="no-relatedrisk">{labels.noRiskHasBeenRelatedMsg}</span>
						</section>
					)
				) : (
					<>
						<section className="related-risks">
							<span className="relatedrisk-name">
								<Icon src={actionIcCheckCircle24px} />
								<span className="relatedrisk-name-label">{labels.notAROMM}</span>
							</span>
						</section>
						{props.item.rationale ? (
							<section className="related-risks rationale-ellipse">
								<span className="rationale-entered">
									<EllipseControl
										content={props.item.rationale}
										tooltip={props.item.rationale}
										noOfLines={3}
										tooltipClass="tooltipCustomWidth"
									/>
								</span>
							</section>
						) : (
							<section className="related-risks">
								<span className="rationale-entered rationale-incomplete">
									<Icon src={contentIcRemoveCircleOutline24px} />
									{labels.rationaleIncompleteMsg}
								</span>
							</section>
						)}
					</>
				)}
			</StyledDefineRiskItem>
		</>
	);
};

export default DefineRiskItem;

const StyledDefineRiskItem = styled.li`
	.risktype-badge {
		border-radius: var(--px-4);
		padding: var(--px-2) var(--px-8);
		background: var(--red-700);
		color: var(--neutrals-00white);
		font-size: var(--px-12);
		font-style: italic;
		font-weight: normal;
		cursor: default;
		margin-right: var(--px-10);
	}
	.related-risks {
		display: inline-block;
		.relatedrisk-name {
			display: inline-block;
		}
		.relatedrisk-name-label {
			display: inline-block;
			width: auto;
			max-width: 95%;
			vertical-align: top;
		}
	}
`;
